export default {"src":"/_next/static/media/boom_40.3cb012d3.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};